import {axios} from './request';


//post请求
function postAction(url,parameter) {
  return axios({
    url: url,
    method:'post' ,
    data: parameter
  })
}
//get请求
function getAction(url,parameter) {
  return axios({
    url: url,
    method: 'get',
    params: parameter
  })
}

function downFile(parameter){
  return axios({
    url: '/file_system/download/',
    params: parameter,
    method:'get' ,
    responseType: 'blob'
  })
}
//抛出
export {
  postAction,
  getAction,
  downFile
}